import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';

const importIntegrations = () => import(/* webpackChunkName: "integrations" */ './containers/IntegrationsContainer');

const IntegrationsRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <SentryBoundary owner={sentryConstants.TEAMS.PERFORMANCE}>
      <BundleRoute
        load={importIntegrations}
        path={match.url}
      />
    </SentryBoundary>
  </LoginRequiredContainer>
);

IntegrationsRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default IntegrationsRoutes;
